<template>
    <div id="map-position-history-widget-component">
        <widget-wrapper-component
            :title="$t('map_position_history_widget_component.list_positions')"
            id-widget="map-position-history-widget"
        >
            <template v-slot:default>
                <template v-if="device">
                    <date-range-picker-component
                        :date_range="date_range"
                        :loading="fetching_coordinate"
                        class="mb-4"
                        v-on:update="updateRangeDate"
                    />

                    <div class="display-flex-align-center mb-2 font-12 font-color-normal">
                        <span class="mr-2">
                            {{ $t('map_position_history_widget_component.start_journey') }}
                        </span>

                        <svg class="my-auto" height="14" viewBox="0 0 300 40" xmlns="http://www.w3.org/2000/svg">
                            <rect fill="#1DB9F3" fill-opacity="0.6" height="32" width="267.396" x="17.592" y="4" />
                            <ellipse cx="20" cy="20" fill="#EA4335" rx="20" ry="20" />
                            <ellipse cx="100" cy="20" fill="#1DB9F3" rx="20" ry="20" />
                            <ellipse cx="200" cy="20" fill="#1DB9F3" rx="20" ry="20" />
                            <ellipse cx="280" cy="20" fill="#65B265" rx="20" ry="20" />
                        </svg>

                        <span class="ml-2">
                            {{ $t('map_position_history_widget_component.end_journey') }}
                        </span>
                    </div>

                    <div v-show="markers.length > 0" ref="mapContainer" class="google-map-container"></div>

                    <v-alert v-if="!fetching_coordinate && markers.length === 0" text color="info" icon="mdi-information-outline">
                        {{ $t('global.no_GPS_data') }}
                    </v-alert>
                </template>

                <template v-else>
                    {{ $t('map_position_history_widget_component.no_geolocation_sensor') }}
                </template>
            </template>
        </widget-wrapper-component>
    </div>
</template>

<script>
import maplibre from '@/mixin/maplibre'
import WidgetWrapperComponent from '@/components/global/wrapper/WidgetWrapperComponent.vue'
import DateRangePickerComponent from '@/components/global/picker/DateRangePickerComponent.vue'
import DeviceRepository from '@/repositories/DeviceRepository'

export default {
    name: 'MapPositionHistoryWidgetComponent',
    components: { DateRangePickerComponent, WidgetWrapperComponent },
    mixins: [maplibre],
    props: {
        device: {
            required: true,
        },
    },
    data() {
        return {
            date_range: {
                startDate: this.moment().clone().startOf('day').subtract(12, 'month').toDate(),
                endDate: this.moment().toDate(),
            },
            fetching_coordinate: true,

            markers: [],
            isMapInitialized: false,
        }
    },
    methods: {
        updateRangeDate(date_range) {
            this.date_range = date_range
            this.fetchDeviceTraitedData()
        },

        fetchDeviceTraitedData() {
            this.fetching_coordinate = true

            DeviceRepository.getCoordinatesByDevice(
                this.device.id_device,
                new URLSearchParams({
                    date_start: this.setDateForRequest(this.date_range.startDate),
                    date_end: this.setDateForRequest(this.date_range.endDate),
                })
            )
                .then((success) => {
                    this.buildTrackPoints(success.data.data.data)
                })
                .catch((error) => {
                    this.manageError(error)
                })
                .finally(() => {
                    this.fetching_coordinate = false
                    this.renderMap()
                })
        },

        buildTrackPoints(device_traited_data) {
            const points = []

            device_traited_data.forEach((dtd) => {
                if (dtd.lat && dtd.lng) {
                    points.push({
                        latitude: parseFloat(dtd.lat),
                        longitude: parseFloat(dtd.lng),
                        date_releve: dtd.date_releve,
                        type: 'mid',
                    })
                }
            })

            if (points.length >= 2) {
                points[0].type = 'start'
                points[points.length - 1].type = 'end'
            }

            this.markers = points
        },

        renderMap() {
            if (!this.markers.length) {
                this.clearTrack()
                return
            }

            this.$nextTick(() => {
                if (!this.isMapInitialized) {
                    this.initMapLibre(this.$refs.mapContainer, { center: { lat: 47, lng: 5 }, zoom: 5 })
                    this.isMapInitialized = true
                } else {
                    this.resizeMapLibre()
                }

                this.renderTrack({ points: this.markers })
                this.fitTrackBounds({ points: this.markers })
            })
        },
    },
    created() {
        if (this.device) {
            this.fetchDeviceTraitedData()
        }
    },
}
</script>
